import gql from 'graphql-tag';

export const METRIC_STATISTICS_AGGREGATION_QUERY = gql`
  query MetricStatisticsAggregationQuery(
    $entityName: String!
    $filters: JSONString!
    $limit: Int!
    $order: String!
    $projectName: String!
    $metricName: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      runs(first: $limit, order: $order, filters: $filters) {
        metricStatisticsAggregation(metricName: $metricName)
        __typename
      }
      __typename
    }
  }
`;

export const METRIC_STATISTICS_QUERY = gql`
  query MetricStatisticsQuery(
    $entityName: String!
    $filters: JSONString!
    $limit: Int!
    $order: String!
    $projectName: String!
    $metricName: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      runs(first: $limit, order: $order, filters: $filters) {
        metricStatistics(metricName: $metricName)
        __typename
      }
      __typename
    }
  }
`;
